import _ from 'underscore';
import BaseCtrl from 'edge/platform/base/BaseCtrl';
import { PhoneNumberUtil } from 'libphonenumber';
import Submission from '../models/Submission';

var fn = function fn($scope, $window, LocaleService, $stateParams, EventHub) {
    var ctrl = Object.create(BaseCtrl);

    var phoneUtils = PhoneNumberUtil.getInstance();

    ctrl.init = function () {
        $scope.submission = new Submission($stateParams.quoteSummary);

        $scope.chosenQuote = _.findWhere($scope.submission.quoteData.offeredQuotes, {
            publicID: $scope.submission.bindData.chosenQuote
        });
        $scope.chosenPlan = _.findWhere($scope.submission.bindData.paymentPlans, {
            billingId: $scope.submission.bindData.selectedPaymentPlan
        });

        $scope.accountHolderAddress = $scope.submission.baseData.policyAddress;
        $scope.accountHolder = $scope.submission.baseData.accountHolder;
        $scope.accountHolder.contactNumber = $scope.accountHolder.homeNumber; // alternative if we need to use primary contact number this._contactNumber();
        EventHub.publish('journey', 'purchase', ctrl.createPurchaseEvent());
    };

    ctrl.createPurchaseEvent = function () {
        var submission = $scope.submission;
        var bindData = submission.bindData;
        var chosenQuote = $scope.chosenQuote;
        return {
            id: submission.quoteID,
            accountNumber: bindData.accountNumber,
            policyNumber: bindData.policyNumber,
            offering: chosenQuote.branchName,
            taxes: chosenQuote.premium.taxes,
            total: chosenQuote.premium.total,
            totalBeforeTaxes: chosenQuote.premium.totalBeforeTaxes,
            productName: submission.baseData.productName,
            paymentPlans: bindData.paymentPlans
        };
    };

    ctrl.printQuote = function () {
        $window.print();
    };

    ctrl._contactNumber = function () {
        var acctHolder = $scope.submission.baseData.accountHolder;
        var phoneType = acctHolder.primaryPhoneType;
        if (phoneType === null) {
            return;
        }

        var number = void 0;
        if (phoneType === 'work') {
            number = acctHolder.workNumber;
        } else if (phoneType === 'home') {
            number = acctHolder.homeNumber;
        } else if (phoneType === 'mobile') {
            number = acctHolder.cellNumber;
        }
        if (number === null) {
            return;
        }

        return phoneUtils.format(phoneUtils.parse(number, LocaleService.getConfiguredPhoneRegion()));
    };

    return ctrl.create($scope);
};
fn.$inject = ['$scope', '$window', 'LocaleService', '$stateParams', 'EventHub'];
export default fn;


//////////////////
// WEBPACK FOOTER
// ./app/customer/js/src/edge/quoteandbind/common/controllers/ConfirmationCtrl.js
// module id = 835
// module chunks = 0